module.exports = __webpack_public_path__ + "img/cww_12.921d1350.jpg";